require('./managePopupNotification.i18n.json');
require('./managePopupNotification.tpl.html');
require('./header/managePopupNotificationHeaderComponent.js');

/*@ngInject*/
const ManagePopupNotificationController = function ($rootScope, $scope, $stateParams, localization, configurationConstant, notificationPreferencesAction, notificationPopupTemplateRepository, notificationPopupTemplateModel, currentUserModel, authorizationConstants) {

    localization.getTranslations('managePopupNotification').then(function (translations) {

        $scope.viewModel = {
            backButtonLabel: _.get(translations, 'backButtonLabel'),
            notificationPreferencesAction: notificationPreferencesAction,
            isReadOnly : !currentUserModel.hasAuthorization(authorizationConstants.MANAGE_POPUP_NOTIFICATIONS),
            templateId: $stateParams.templateId,
            notificationPopupTemplate: {
                enabled: true,
                include: 'everyone',
                deletable: true
            },
            namePrompt: translations.managePopupNotification.namePrompt,
            titlePrompt: translations.managePopupNotification.titlePrompt,
            messagePrompt: translations.managePopupNotification.messagePrompt
        };
        notificationPopupTemplateModel.notificationPopupTemplate = $scope.viewModel.notificationPopupTemplate;

        if ($stateParams.templateId) {
            notificationPopupTemplateRepository.getNotificationPopupTemplate($stateParams.templateId).then(function (notificationPopupTemplate) {
                notificationPopupTemplate.include = 'everyone';
                if (notificationPopupTemplate.excludeConsole) {
                    if (notificationPopupTemplate.excludeConsole === 'Underwriter') {
                        notificationPopupTemplate.include = 'onlyProducer';
                    } else if (notificationPopupTemplate.excludeConsole === 'Producer') {
                        notificationPopupTemplate.include = 'onlyUnderwriter';
                    }
                }
                $scope.viewModel.notificationPopupTemplate = _.cloneDeep(notificationPopupTemplate);
                notificationPopupTemplateModel.reset();
                notificationPopupTemplateModel.notificationPopupTemplate = $scope.viewModel.notificationPopupTemplate;
                if (notificationPopupTemplateModel.notificationPopupTemplate.body) {
                    notificationPopupTemplateModel.notificationPopupTemplate.body =
                        notificationPopupTemplateModel.notificationPopupTemplate.body.replace(/\\n/g, '\r\n');
                }
                $rootScope.$broadcast(configurationConstant.event.EMAIL_TEMPLATE_UPDATED);
            });
        }
    });

    $scope.handleChange = function () {
        const notificationPopupTemplate = notificationPopupTemplateModel.notificationPopupTemplate;
        if (notificationPopupTemplate.include === 'everyone') {
            notificationPopupTemplate.excludeConsole = null;
        }
        else if (notificationPopupTemplate.include === 'onlyProducer') {
            notificationPopupTemplate.excludeConsole = 'Underwriter';
        }
        else if (notificationPopupTemplate.include === 'onlyUnderwriter') {
            notificationPopupTemplate.excludeConsole = 'Producer';
        }
        notificationPopupTemplateModel.hasUnsavedChanges = true;
        notificationPopupTemplateModel.isValid = isValid();
        $rootScope.$broadcast(configurationConstant.event.EMAIL_TEMPLATE_UPDATED);
    };

    function isValid() {
        const hasName = !_.isEmpty(notificationPopupTemplateModel.notificationPopupTemplate.name),
            hasStatus = notificationPopupTemplateModel.notificationPopupTemplate.enabled != null,
            hasTitle = !_.isEmpty(notificationPopupTemplateModel.notificationPopupTemplate.title),
            hasMessage = !_.isEmpty(notificationPopupTemplateModel.notificationPopupTemplate.body),
            hasInclude = !_.isEmpty(notificationPopupTemplateModel.notificationPopupTemplate.include);

        let result = false; // we need to always return something if the method is intended to return something

        if (hasName && hasStatus && hasTitle && hasMessage && hasInclude) {
            result = true;
        }

        return result;
    }
};

angular.module('ums.configuration')
    .controller('managePopupNotificationController', ManagePopupNotificationController);
